import { DrinksPerDay } from "@dcc/types/drinkingDay";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { getTotalWeeklyDrinks } from "@dcc/score/weekly";

export const getTotalWeeklyDrinkCount = ({
  drinksByDay,
  drinkFrequency,
  numberOfMonthlyDrinkingDays
}: {
  drinksByDay: DrinksPerDay[];
  drinkFrequency: DrinkFrequency | undefined;
  numberOfMonthlyDrinkingDays: number;
}) =>
  drinkFrequency
    ? getTotalWeeklyDrinks({
        drinksByDay,
        drinkFrequency,
        numberOfMonthlyDrinkingDays
      })
    : 0;
